import {
  Wrench, Home, Building2, Droplets, Layers, Sun, Search, ClipboardCheck,
} from "lucide-react";

export const SERVICES = [
  {
    slug: "roof-repairs",
    icon: Wrench,
    name: "Roof Repairs",
    tagline: "Fast, lasting fixes for leaks, cracks & storm damage.",
    blurb:
      "From a single slipped tile to storm-torn sheeting, we track down the real cause and repair it properly the first time — no band-aid jobs.",
    points: [
      "Leak detection & water-ingress repairs",
      "Storm & wind damage restoration",
      "Tile, ridge capping & pointing repairs",
      "Emergency make-safe call-outs across Perth",
    ],
    forResidential: true,
    forCommercial: true,
  },
  {
    slug: "roof-replacement-reroofing",
    icon: Home,
    name: "Roof Replacement & Re-roofing",
    tagline: "A brand-new roof, installed clean and on budget.",
    blurb:
      "Tired tile or rusted metal? We strip and replace with modern Colorbond-style steel for a roof that looks sharp and performs for decades.",
    points: [
      "Full tile-to-metal re-roofing",
      "Colorbond & Zincalume sheet replacement",
      "Insulation & sarking upgrades",
      "Fixed-price quotes, tidy site every day",
    ],
    forResidential: true,
    forCommercial: true,
  },
  {
    slug: "commercial-remedial-roofing",
    icon: Building2,
    name: "Commercial & Large-scale Remedial Roofing",
    tagline: "Multi-faceted remedial works on significant property assets.",
    blurb:
      "We deliver large-scale, multi-stage roofing programs for property managers and commercial clients — staged, safe and minimally disruptive to tenants.",
    points: [
      "Industrial & strata re-roofing programs",
      "Remedial works on ageing commercial assets",
      "Height-safety, access & compliance managed",
      "Project-managed by a qualified roof plumber",
    ],
    forResidential: false,
    forCommercial: true,
  },
  {
    slug: "gutters-downpipes",
    icon: Droplets,
    name: "Gutters & Downpipes",
    tagline: "Keep the water moving and your walls dry.",
    blurb:
      "New gutters, downpipes and rainheads sized correctly for Perth's downpours — installed in colours that match your roofline.",
    points: [
      "Gutter replacement & realignment",
      "Downpipe & stormwater connections",
      "Leaf guard & gutter protection",
      "Fascia & barge capping",
    ],
    forResidential: true,
    forCommercial: true,
  },
  {
    slug: "roof-sheeting-flashings",
    icon: Layers,
    name: "Roof Sheeting & Flashings",
    tagline: "Watertight detailing where it matters most.",
    blurb:
      "Precision-folded flashings and quality sheeting installed to spec — the difference between a roof that lasts and one that leaks.",
    points: [
      "Colorbond roof & wall sheeting",
      "Custom-folded flashings & cappings",
      "Valley, ridge & penetration flashing",
      "Box gutters & parapet detailing",
    ],
    forResidential: true,
    forCommercial: true,
  },
  {
    slug: "skylights",
    icon: Sun,
    name: "Skylights",
    tagline: "Bring natural light flooding in.",
    blurb:
      "Supply and install of fixed and ventilating skylights and roof windows — sealed and flashed properly so they never leak.",
    points: [
      "Fixed & ventilating skylights",
      "Velux-style roof windows",
      "Tube / solar skylights",
      "Leak-proof flashing & sealing",
    ],
    forResidential: true,
    forCommercial: true,
  },
  {
    slug: "roof-inspections-leak-detection",
    icon: Search,
    name: "Roof Inspections & Leak Detection",
    tagline: "Know exactly what's going on up there.",
    blurb:
      "Thorough inspections with photo evidence and honest advice. We find leaks others miss and tell you what actually needs doing.",
    points: [
      "Pre-purchase & pre-storm inspections",
      "Specialist leak detection",
      "Detailed photo reporting",
      "Honest repair-vs-replace advice",
    ],
    forResidential: true,
    forCommercial: true,
  },
  {
    slug: "roofing-reports-maintenance",
    icon: ClipboardCheck,
    name: "Roofing Reports & Maintenance",
    tagline: "Protect your asset with a maintenance plan.",
    blurb:
      "Scheduled maintenance and formal condition reports for homeowners, property managers and bodies corporate — stay ahead of the wet season.",
    points: [
      "Condition & dilapidation reports",
      "Scheduled preventative maintenance",
      "Gutter cleans & minor repairs",
      "Asset reports for property managers",
    ],
    forResidential: true,
    forCommercial: true,
  },
];

export const JOB_TYPES = [
  "Roof Repairs",
  "Roof Replacement / Re-roofing",
  "Commercial Roofing",
  "Gutters & Downpipes",
  "Sheeting & Flashings",
  "Skylights",
  "Inspection / Leak Detection",
  "Roofing Report / Maintenance",
  "Not sure / Other",
];

export const SUBURBS = [
  { slug: "victoria-park", name: "Victoria Park", blurb: "Our home base. Heritage tile and modern metal roofs across the 6100." },
  { slug: "perth-cbd", name: "Perth CBD", blurb: "Commercial and apartment roofing in the heart of the city." },
  { slug: "fremantle", name: "Fremantle", blurb: "Coastal homes and character properties built to handle the sea breeze." },
  { slug: "joondalup", name: "Joondalup", blurb: "Family homes and commercial assets across the northern corridor." },
  { slug: "scarborough", name: "Scarborough", blurb: "Beachside re-roofing that stands up to salt and sun." },
  { slug: "subiaco", name: "Subiaco", blurb: "Premium repairs and re-roofs for Subi's character homes." },
  { slug: "cottesloe", name: "Cottesloe", blurb: "High-end residential roofing on the western suburbs coast." },
  { slug: "canning-vale", name: "Canning Vale", blurb: "Suburban homes and large industrial roofing in the south-east." },
  { slug: "morley", name: "Morley", blurb: "Repairs, gutters and replacements across the north-east." },
  { slug: "mandurah", name: "Mandurah", blurb: "Servicing the Peel region for residential and commercial roofing." },
];

export const TESTIMONIALS = [
  { name: "Sarah M.", suburb: "Victoria Park", text: "West Face re-roofed our place and the finish is immaculate. On time, tidy, and the price was exactly as quoted." },
  { name: "David T.", suburb: "Bentley", text: "Had a leak three other roofers couldn't find. West Face located it in twenty minutes and fixed it properly. Honest tradesmen." },
  { name: "Property Group WA", suburb: "Perth CBD", text: "Managed a large commercial remedial job across two sites. Professional from quote to completion." },
  { name: "Megan R.", suburb: "Morley", text: "New gutters and downpipes installed in a day. Quality workmanship and genuinely friendly." },
];

export const GALLERY = [
  { url: "https://images.pexels.com/photos/8811591/pexels-photo-8811591.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=1200", title: "Geometric rooftop — drone", cat: "Commercial" },
  { url: "https://images.unsplash.com/photo-1602064828974-fcac67d33f4e?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200", title: "Dark Colorbond re-roof", cat: "Residential" },
  { url: "https://images.pexels.com/photos/3097390/pexels-photo-3097390.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=1200", title: "Industrial roof patterns — aerial", cat: "Commercial" },
  { url: "https://images.unsplash.com/photo-1776653244534-69d59028af6c?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200", title: "Rooftop plant on corrugated steel", cat: "Commercial" },
  { url: "https://images.unsplash.com/photo-1602193230480-7840a38eb0c3?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200", title: "Metal roof against weather", cat: "Residential" },
  { url: "https://images.unsplash.com/photo-1758304481551-25138093050b?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200", title: "Commercial re-roof — aerial", cat: "Commercial" },
  { url: "https://images.unsplash.com/photo-1602193458517-db6caca8f1fe?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200", title: "Grey steel roofing detail", cat: "Residential" },
  { url: "https://images.unsplash.com/photo-1770910452211-2e8fd91bc347?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200", title: "Modern standing-seam roof", cat: "Commercial" },
  { url: "https://images.unsplash.com/photo-1628002881911-8bcdfbdf320e?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200", title: "Bold profile cladding", cat: "Residential" },
  { url: "https://images.unsplash.com/photo-1635249578213-68b0aa67fdf7?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200", title: "On the tools in Perth", cat: "Team" },
];

// To use your own hero video, set HERO_VIDEO to its mp4 URL. Leave it "" to use HERO_IMAGE.
export const HERO_VIDEO = "";
export const HERO_IMAGE = "https://images.pexels.com/photos/4933643/pexels-photo-4933643.jpeg?auto=compress&cs=tinysrgb&w=1920";
